import {
  BarChart3,
  Briefcase,
  CheckCircle,
  Home,
  MapPin,
  Users,
} from "lucide-react";

import { formMode } from "@/components/auth/form-mode";

export const SIGNIN_CONFIG = {
  heroTitle: "Find Your Perfect Teaching Position",
  heroDescription:
    "Connect with schools and discover opportunities that match your skills.",
  features: [
    {
      icon: <Users size={20} />,
      title: "Personalized Matches",
      description: "Get matched with schools that align with your preferences",
    },
    {
      icon: <MapPin size={20} />,
      title: "Explore by Location",
      description: "Search for opportunities in your preferred states",
    },
    {
      icon: <CheckCircle size={20} />,
      title: "Simple Applications",
      description: "Apply to multiple positions with your saved profile",
    },
  ],
};

export const SIGNUP_CONFIG = {
  heroTitle: "Join Thousands of Educators",
  heroDescription:
    "Start your journey and connect with schools that value your expertise.",
  features: [
    {
      icon: <Users size={20} />,
      title: "Build Your Profile",
      description: "Showcase your experience and teaching philosophy",
    },
    {
      icon: <Home size={20} />,
      title: "Get Discovered",
      description: "Schools can reach out to you directly with opportunities",
    },
    {
      icon: <BarChart3 size={20} />,
      title: "Track Applications",
      description: "Manage all your job applications in one place",
    },
  ],
};

const jobSeekerSubtitle = "For anyone looking for a role in K-12 education.";

export const JOB_SEEKER_HEADINGS = {
  [formMode.signin]: {
    title: "Sign in to keep applying",
    subtitle: jobSeekerSubtitle,
  },
  [formMode.signup]: {
    title: "Create your job seeker account",
    subtitle: jobSeekerSubtitle,
  },
} as const;

export const DISTRICT_STAFF_SIGNIN_CONFIG = {
  title: "Sign in to begin hiring",
  subtitle: "For principals, HR, and district staff.",
  heroEyebrow: "Principals, HR & district staff",
  heroTitle: "Hire for every school in your district",
  heroDescription:
    "One place for postings, candidates, and the people who review them.",
  features: [
    {
      icon: <Briefcase size={20} />,
      title: "Post once, reach more teachers",
      description:
        "Every job you post reaches candidates on Nimble the moment it is live.",
    },
    {
      icon: <Users size={20} />,
      title: "Review together",
      description:
        "Principals and HR each see the candidates they are responsible for.",
    },
    {
      icon: <CheckCircle size={20} />,
      title: "One sign-in, all of Nimble",
      description: "Sign in once, access every Nimble tool your district uses.",
    },
  ],
};
